export const TEMP_ATTRIBUTES_CODES = [
    'BT',
    'CT',
    'Gct',
    'Get',
    'Gwt',
    'McT',
    'ScT',
    'T1',
    'c0T',
    'coT',
    'fcab1',
    'fcab2',
    'fcrt1',
    'fcst1',
    'fcst2',
    'fcst3',
    'fcst4',
    'glT',
    'mcT',
    'msC',
    'msT',
    'mt',
    'tsT',
    'bT',
];

export const MONETARY_ATTRIBUTES_CODES = ['deBc', 'deGs', 'deGb'];
